import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/word_groups.json";
import fr from "@/locales/fr/puzzle-types/word_groups.json";

export const WORD_GROUPS_NS = "puzzle-types/word_groups";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerWordGroupsTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", WORD_GROUPS_NS))
    i18n.addResourceBundle("en", WORD_GROUPS_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", WORD_GROUPS_NS))
    i18n.addResourceBundle("fr", WORD_GROUPS_NS, fr, true, true);
}
